import { t } from "i18next";
import { GET_INSTANCE_INFO, INSTANCE_INFO_ERROR } from "./types";

const InstanceReducer = (state, action) => {
    const { payload, type } = action;
    switch (type) {
        case GET_INSTANCE_INFO:
            return {
                ...state,
                instanceInfo: payload,
                isFetching: false,
            }

        case INSTANCE_INFO_ERROR:
            return {
                ...state,
                isFetching: false,
                error: true,
                message: t('INSTANCE_INFO_ERROR')
            }

        default:
            return state

    }
}

export default InstanceReducer